"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSliderDoubleBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var helpers_1 = require("../../../common/helpers");
var bc_slider_constants_1 = require("./bc-slider-constants");
var bc_slider_constants_2 = require("./bc-slider-constants");
var bc_slider_constants_3 = require("./bc-slider-constants");
var bc_slider_constants_4 = require("./bc-slider-constants");
var bc_slider_constants_5 = require("./bc-slider-constants");
var bc_slider_constants_6 = require("./bc-slider-constants");
var tooltip_constants_1 = require("../../molecules/bc-tooltip/tooltip-constants");
var BcSliderDoubleBehavior = (function (_super) {
    __extends(BcSliderDoubleBehavior, _super);
    function BcSliderDoubleBehavior() {
        var _this = _super.call(this) || this;
        _this.totalLeft = 0;
        _this.totalRight = 0;
        _this.hasTooltips = false;
        return _this;
    }
    Object.defineProperty(BcSliderDoubleBehavior.prototype, "sliderLeftValue", {
        get: function () {
            return parseInt(this.sliderLeft.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BcSliderDoubleBehavior.prototype, "sliderRightValue", {
        get: function () {
            return parseInt(this.sliderRight.value);
        },
        enumerable: false,
        configurable: true
    });
    BcSliderDoubleBehavior.prototype._setUp = function () {
        this.setElement(this.mySelf);
        this.addInputListeners();
        this.addTooltipListeners(this.sliderLeft, this.tooltipLeft);
        this.addTooltipListeners(this.sliderRight, this.tooltipRight);
        this.updateLeftInput();
        this.updateRightInput();
    };
    BcSliderDoubleBehavior.prototype.setValue = function (leftValue, rightValue) {
        if (leftValue > rightValue) {
            this.sliderLeft.value = "".concat(rightValue);
            this.sliderRight.value = "".concat(leftValue);
        }
        else {
            this.sliderLeft.value = "".concat(leftValue);
            this.sliderRight.value = "".concat(rightValue);
        }
        this.updateLeftInput();
        this.updateRightInput();
    };
    BcSliderDoubleBehavior.prototype.enableTooltips = function () {
        this.hasTooltips = true;
    };
    BcSliderDoubleBehavior.prototype.setElement = function (element) {
        this.sliderLeft = element.querySelector("input[class^='".concat(bc_slider_constants_1.SLIDER_DOUBLE_INPUT_LEFT_CLASS, "']"));
        this.sliderRight = element.querySelector("input[class^='".concat(bc_slider_constants_1.SLIDER_DOUBLE_INPUT_RIGHT_CLASS, "']"));
        this.thumbLeft = this.setThumb(this.sliderLeft, bc_slider_constants_2.SLIDER_DOUBLE_THUMB_LEFT_CLASS);
        this.thumbRight = this.setThumb(this.sliderRight, bc_slider_constants_2.SLIDER_DOUBLE_THUMB_RIGHT_CLASS);
        this.setTrack();
        this.setTooltips();
    };
    BcSliderDoubleBehavior.prototype.setThumb = function (slider, thumbClass) {
        var thumb = this.mySelf.querySelector("div[class^='".concat(thumbClass, "']"));
        if (thumb === null) {
            var newThumb = document.createElement('div');
            newThumb.classList.add(thumbClass);
            this.mySelf.appendChild(newThumb);
            thumb = newThumb;
        }
        (0, helpers_1.addFocusable)(slider, null, null, [thumb]);
        return thumb;
    };
    BcSliderDoubleBehavior.prototype.setTrack = function () {
        this.track = this.mySelf.querySelector("div[class^='".concat(bc_slider_constants_3.SLIDER_DOUBLE_TRACK_CLASS, "']"));
        if (this.track === null) {
            var track = document.createElement('div');
            track.classList.add(bc_slider_constants_3.SLIDER_DOUBLE_TRACK_CLASS);
            this.track = track;
            this.setFilledTrack();
            this.mySelf.insertBefore(track, this.sliderLeft);
            return;
        }
        this.setFilledTrack();
    };
    BcSliderDoubleBehavior.prototype.setFilledTrack = function () {
        this.filledTrack = this.track.querySelector("div[class^='".concat(bc_slider_constants_3.SLIDER_DOUBLE_TRACK_FILL_CLASS, "']"));
        if (this.filledTrack === null) {
            var filledTrack = document.createElement('div');
            filledTrack.classList.add(bc_slider_constants_3.SLIDER_DOUBLE_TRACK_FILL_CLASS);
            this.track.appendChild(filledTrack);
            this.filledTrack = filledTrack;
        }
    };
    BcSliderDoubleBehavior.prototype.setTooltips = function () {
        if (!this.hasTooltips) {
            this.tooltipLeft = null;
            this.tooltipRight = null;
            return;
        }
        var leftTooltip = this.createTooltip('left');
        this.tooltipLeft = leftTooltip.div;
        this.tooltipTextLeft = leftTooltip.p;
        this.mySelf.insertBefore(this.tooltipLeft, this.sliderLeft);
        var rightTooltip = this.createTooltip('right');
        this.tooltipRight = rightTooltip.div;
        this.tooltipTextRight = rightTooltip.p;
        this.mySelf.insertBefore(this.tooltipRight, this.sliderRight);
    };
    BcSliderDoubleBehavior.prototype.createTooltip = function (identifierClass) {
        var tooltip = document.createElement('div');
        tooltip.classList.add(bc_slider_constants_4.SLIDER_TOOLTIP);
        tooltip.classList.add(identifierClass);
        tooltip.classList.add(tooltip_constants_1.BC_TOOLTIP_CONTAINER_SELECTOR);
        var tooltipText = document.createElement('p');
        var tooltipArrow = document.createElement('div');
        tooltipArrow.classList.add(tooltip_constants_1.BC_TOOLTIP_ARROW_CLASS);
        tooltipArrow.classList.add("".concat(tooltip_constants_1.BC_TOOLTIP_ARROW_CLASS, "--top"));
        tooltip.appendChild(tooltipText);
        tooltip.appendChild(tooltipArrow);
        return { div: tooltip, p: tooltipText };
    };
    BcSliderDoubleBehavior.prototype.updateLeftInput = function () {
        this.totalLeft = this.calculateTotal(this.sliderLeft, this.sliderRightValue);
        this.defineCssProperties(this.totalLeft, this.sliderLeft, 'Left');
        this.offsetFocusableThumb(this.totalLeft, this.thumbLeft);
        this.updateTrack();
        this.updateTooltip(this.tooltipLeft, this.tooltipTextLeft, this.totalLeft);
        this.sliderLeft.style.zIndex = this.totalLeft === bc_slider_constants_6.SLIDER_N100 ? "".concat(bc_slider_constants_5.SLIDER_N10) : '0';
        this.outputValues();
    };
    BcSliderDoubleBehavior.prototype.updateRightInput = function () {
        this.totalRight = this.calculateTotal(this.sliderRight, this.sliderLeftValue);
        this.defineCssProperties(this.totalRight, this.sliderRight, 'Right');
        this.offsetFocusableThumb(this.totalRight, this.thumbRight);
        this.updateTrack();
        this.updateTooltip(this.tooltipRight, this.tooltipTextRight, this.totalRight);
        this.outputValues();
    };
    BcSliderDoubleBehavior.prototype.outputValues = function () {
        if (this.outputFunction) {
            this.outputFunction({
                leftValue: this.sliderLeftValue,
                rightValue: this.sliderRightValue,
                leftPercentage: this.totalLeft,
                rightPercentage: this.totalRight,
            });
        }
    };
    BcSliderDoubleBehavior.prototype.calculateTotal = function (slider, otherSliderValue) {
        if (this.sliderRightValue - this.sliderLeftValue <= 0) {
            slider.value = "".concat(otherSliderValue);
        }
        var minValue = parseInt(slider.getAttribute('min'));
        var maxValue = parseInt(slider.getAttribute('max'));
        var rangeSize = maxValue - minValue;
        var currentValue = parseInt(slider.value);
        return ((currentValue - minValue) * bc_slider_constants_6.SLIDER_N100) / rangeSize;
    };
    BcSliderDoubleBehavior.prototype.defineCssProperties = function (total, slider, position) {
        var thumbOffset = (bc_slider_constants_5.SLIDER_N20 * total) / bc_slider_constants_6.SLIDER_N100 - bc_slider_constants_5.SLIDER_N10;
        var thumbOffsetOnHover = (bc_slider_constants_5.SLIDER_N24 * total) / bc_slider_constants_6.SLIDER_N100 - bc_slider_constants_5.SLIDER_N12;
        slider.style.setProperty("--value".concat(position), "".concat(total));
        slider.style.setProperty("--thumbOffset".concat(position), "".concat(thumbOffset, "px"));
        slider.style.setProperty("--thumbOffset".concat(position, "OnHover"), "".concat(thumbOffsetOnHover, "px"));
        slider.setAttribute('aria-valuenow', slider.value);
    };
    BcSliderDoubleBehavior.prototype.offsetFocusableThumb = function (total, thumb) {
        var offset = (bc_slider_constants_6.SLIDER_N32 * total) / bc_slider_constants_6.SLIDER_N100;
        thumb.style.left = "calc(".concat(total, "% - ").concat(offset, "px)");
    };
    BcSliderDoubleBehavior.prototype.updateTrack = function () {
        var leftPercentage = "".concat(this.totalLeft, "%");
        var rightPercentage = "".concat(bc_slider_constants_6.SLIDER_N100 - this.totalLeft - (bc_slider_constants_6.SLIDER_N100 - this.totalRight), "%");
        this.filledTrack.style.left = leftPercentage;
        this.filledTrack.style.width = rightPercentage;
    };
    BcSliderDoubleBehavior.prototype.updateTooltip = function (tooltip, tooltipText, total) {
        if (!this.hasTooltips) {
            return;
        }
        var offset = ((bc_slider_constants_6.SLIDER_N52 - bc_slider_constants_5.SLIDER_N20) / bc_slider_constants_6.SLIDER_N100) * total + bc_slider_constants_5.SLIDER_N20;
        tooltip.style.left = "calc(".concat(total, "% - ").concat(offset, "px)");
        tooltipText.innerText = "".concat(Math.round(total), "%");
    };
    BcSliderDoubleBehavior.prototype.addInputListeners = function () {
        var _this = this;
        this.sliderLeft.addEventListener('input', function () {
            _this.updateLeftInput();
        });
        this.sliderRight.addEventListener('input', function () {
            _this.updateRightInput();
        });
    };
    BcSliderDoubleBehavior.prototype.addTooltipListeners = function (slider, tooltip) {
        if (!this.hasTooltips) {
            return;
        }
        slider.addEventListener('mousedown', function () {
            tooltip.classList.add(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        slider.addEventListener('mouseup', function () {
            tooltip.classList.remove(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        slider.addEventListener('touchstart', function () {
            tooltip.classList.add(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
        slider.addEventListener('touchend', function () {
            tooltip.classList.remove(bc_slider_constants_4.SLIDER_ACTIVE_CLASS);
        });
    };
    return BcSliderDoubleBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSliderDoubleBehavior = BcSliderDoubleBehavior;
